
// @ts-nocheck
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onBeforeMount
} from 'vue'
import { areaList } from '@vant/area-data'
import { useRoute } from 'vue-router'
import rem from '@/utils/rem.js'
import { Toast, ImagePreview } from 'vant'
import request from '@/utils/hbRequest.js'
import setTitle from '@/utils/setTitle'
rem(750, 750)
export default defineComponent({
  name: 'ServiceTempDetail',
  setup() {
    const route = useRoute()
    const state = reactive({
      show: sessionStorage.getItem('writePopup') === '1' ? true : false,
      showSuccess: sessionStorage.getItem('viewPopup') === '1' ? true : false,
      selectAddr: false,
      submitStatus: false,
      form: {
        salesmanId: null,
        activityId: null,
        servingId: null,
        servingCount: 1,
        phone: '',
        identityCard: '',
        province: '',
        city: '',
        district: '',
        address: '',
        userName: '',
        addString: '',
        salesmanName: '',
        salesmanPhone: ''
      },
      price: null,
      total: null,
      fileList: null,
      externalUrl: null,
      checked: true,
      userChecked: false,
      authChecked: false
    })

    setTitle(route.params.activityName || '服务包详情')
    const params = JSON.parse(sessionStorage.getItem('routerParams'))
    state.form.activityId = params.activityId || ''
    state.form.salesmanId = params.salesmanId || ''
    state.form.servingId = params.servingId || ''
    state.price = params.price || 0
    state.total = params.price || 0
    state.fileList = params.fileList || []
    state.externalUrl = params.externalUrl || ''

    // 跳转协议页面后拿缓存中的form
    const serviceForm = sessionStorage.getItem('serviceForm')
    if (serviceForm) {
      state.form = JSON.parse(serviceForm)
      sessionStorage.removeItem('serviceForm')
    }

    watchEffect(() => {
      if (!state.show || !state.showSuccess) {
        sessionStorage.removeItem('writePopup')
        sessionStorage.removeItem('viewPopup')
      }
    })

    onBeforeMount(() => {
      const oScript = document.createElement('script')
      oScript.type = 'text/javascript'
      oScript.src = 'https://pv.sohu.com/cityjson?ie=utf-8'
      document.body.appendChild(oScript)
      setTimeout(() => {
        // 浏览记录
        const params = {
          activityId: state.form.activityId,
          salesmanId: state.form.salesmanId,
          pageUrl: '/huBeiService/serviceDetail',
          servingId: state.form.servingId,
          ip: window.returnCitySN ? window.returnCitySN.cip : ''
        }
        request.post('/spread/visit/record/save', params)
      }, 600)
    })

    // 判断是否已经登记过
    const isRegisterId = async () => {
      const registerId = localStorage.getItem(
        'registerId' + state.form.servingId
      )
      if (registerId) {
        const res = await request.get(
          `/spread/serving/registration/${registerId}/detail`
        )
        // 已经登记
        if (res.data) {
          state.form = Object.assign(state.form, res.data)
          state.submitStatus = true
        }
      }
    }

    isRegisterId()

    const validatorTel = (val) => {
      const reg = /^[1][3,4,5,7,8][0-9]{9}$/
      const flag = reg.test(val)
      if (!flag) {
        return '请输入正确的手机号'
      }
      return true
    }
    const validatorIdCard = (val) => {
      const reg =
        /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X|x]$/
      const flag = reg.test(val)
      if (!flag) {
        return '请输入正确的身份证号'
      }
      return true
    }

    const confirmAddr = (arr) => {
      let srt = ''
      arr.forEach((item) => {
        srt += item.name
      })
      state.form.addString = srt
      state.form.province = arr[0].name || ''
      state.form.city = arr[1].name || ''
      state.form.district = arr[2].name || ''
      state.selectAddr = false
    }
    // 减
    const increase = () => {
      if (state.form.servingCount == 1) return
      state.form.servingCount = state.form.servingCount - 1
      state.total = state.price * state.form.servingCount
    }
    // 加
    const subtract = () => {
      state.form.servingCount = state.form.servingCount + 1
      state.total = state.price * state.form.servingCount
    }

    const onSubmit = async () => {
      if (!state.userChecked) {
        return Toast('请先同意普康宝用户协议')
      }
      if (!state.authChecked) {
        return Toast('请授权使用本人补充医疗保险账户额度')
      }
      const res = await request.post(
        '/spread/serving/registration/save',
        state.form
      )
      if (res.code !== 0) {
        return Toast(res.message)
      }
      Toast('提交成功')
      state.show = false
      state.submitStatus = true
      localStorage.setItem('registerId' + state.form.servingId, res.data)
      isRegisterId()
    }

    const toUserAuth = (key) => {
      sessionStorage.setItem(key, '1')
      if (key === 'writePopup') {
        sessionStorage.setItem('serviceForm', JSON.stringify(state.form))
      }
      window.open(
        'https://pk-activity-h5.pukangbao.com/agreement/privacyAgreement?agreementType=7'
      )
    }

    const toAuthDesc = (key) => {
      sessionStorage.setItem(key, '1')
      if (key === 'writePopup') {
        sessionStorage.setItem('serviceForm', JSON.stringify(state.form))
      }
      window.open(
        'https://pk-activity-h5.pukangbao.com/agreement/privacyAgreement?agreementType=8'
      )
    }

    const callPhone = () => {
      window.location.href = 'tel:' + state.form.salesmanPhone
    }

    const jumpTo = () => {
      window.location.href = state.externalUrl
    }

    const onClickAdditem = () => {
      state.selectAddr = true
      // 屏蔽默认弹出键盘
      document.activeElement.blur()
    }

    return {
      ...toRefs(state),
      validatorTel,
      validatorIdCard,
      onSubmit,
      confirmAddr,
      areaList,
      increase,
      subtract,
      toUserAuth,
      toAuthDesc,
      callPhone,
      jumpTo,
      onClickAdditem
    }
  }
})
